// extracted by mini-css-extract-plugin
module.exports = {"wrap_div":"TeamRequestsManage_wrap_div__3--wO","content_div":"TeamRequestsManage_content_div__1DCqL","teamRequests_table":"TeamRequestsManage_teamRequests_table__-x3qc"};